// src/config/dmLinks.ts hardened/refactored v1
export const DM_LINKS: Record<string, string> = {
  instagram: "https://www.instagram.com/crushhh.hi?igsh=MTMyNjJvb3Z3ajZhag==",
  tiktok: "https://www.tiktok.com/@crushhh2025",
  snapchat: "https://www.snapchat.com/add/crushhhlist?share_id=iIk-Lr1f9iY&locale=en-US",
  facebook: "https://www.facebook.com/share/17UYWASH3Q/",
  linkedin: "https://www.linkedin.com/company/crushhh",
};